import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from '@/types/utils';

// Affected route within a history record
export class IAffectedRoute {
  route_id: number;
  ord: number;
  status_before: number;
  status_after: number;
  session_id: number;
  point_map_id: number;
}

// Operations by step for statistics
export class IOperationByStep {
  step: number;
  count: number;
}

// Main super admin history class
export class ISuperAdminHistory {
  id: string;
  package_id: number;
  barcode: string;
  boxcode: string;
  step: number;
  step_name: string;
  user_id: number;
  user_name: string;
  user_email: string;
  package_before: Record<string, unknown>;
  package_after: Record<string, unknown>;
  @Type(() => IAffectedRoute)
  affected_routes: IAffectedRoute[];
  previous_status: number;
  new_status: number;
  response_data: Record<string, unknown>;
  processed_routes: number;
  total_routes: number;
  success: boolean;
  error_message?: string;
  ip_address: string;
  user_agent: string;
  created_at: string;
  updated_at: string;
}

// Query DTO for filtering
export class ISuperAdminHistoryQueryDto extends IQueryPaginationDto {
  package_id?: number;
  barcode?: string;
  user_id?: number;
  step?: number;
  date_start?: string;
  date_end?: string;
}

// Response for single history record
export class ISuperAdminHistoryResponse {
  @Type(() => ISuperAdminHistory)
  result: ISuperAdminHistory;
}

// Response for list of history records
export class ISuperAdminHistoryListResponse extends IPagination {
  @Type(() => ISuperAdminHistory)
  results: ISuperAdminHistory[];
}

// Statistics response
export class ISuperAdminStatisticsResponse {
  total_operations: number;
  successful_operations: number;
  failed_operations: number;
  @Type(() => IOperationByStep)
  operations_by_step: IOperationByStep[];
  @Type(() => ISuperAdminHistory)
  recent_operations: ISuperAdminHistory[];
}
